import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const WHATSAPP_NUM = "491556724186";
const PHONE_DISPLAY = "+49 155 6724186";
const EMAIL = "auralia-healing@gmx.de";

export default function Footer() {
  return (
    <footer className="bg-[#050510] border-t border-[#C9A84C]/30 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div>
            <h3
              className="text-xl font-light text-[#C9A84C] tracking-[0.18em] mb-1"
              style={{ fontFamily: "Cormorant Garamond, serif" }}
            >
              AURALIA HEALING
            </h3>
            <p className="text-[#9A9A9A] text-[0.65rem] uppercase tracking-[0.25em] mb-5">
              Energie. Heilung. Transformation.
            </p>
            <p className="text-[#9A9A9A] text-sm leading-relaxed mb-5">
              Energetische Begleitung &amp; Remote-Sessions weltweit.
            </p>
            <div className="space-y-2">
              <a
                href={`mailto:${EMAIL}`}
                className="flex items-center gap-2 text-[#9A9A9A] text-sm hover:text-[#C9A84C] transition-colors"
              >
                <Mail size={13} className="text-[#C9A84C]" />
                {EMAIL}
              </a>
              <a
                href={`https://wa.me/${WHATSAPP_NUM}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#9A9A9A] text-sm hover:text-[#C9A84C] transition-colors"
              >
                <Phone size={13} className="text-[#C9A84C]" />
                {PHONE_DISPLAY} (auch WhatsApp)
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-[0.65rem] uppercase tracking-[0.3em] text-[#C9A84C] mb-6">
              Navigation
            </p>
            <div className="flex flex-col gap-3">
              {[
                { href: "/", label: "Start" },
                { href: "/leistungen", label: "Leistungen" },
                { href: "/ueber-auralia", label: "Über Auralia Healing" },
                { href: "/faq", label: "FAQ" },
                { href: "/fragebogen", label: "Vorbereitungsfragebogen" },
                { href: "/kontakt", label: "Kontakt" },
              ].map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-[#9A9A9A] text-sm hover:text-[#C9A84C] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div>
            <p className="text-[0.65rem] uppercase tracking-[0.3em] text-[#C9A84C] mb-6">
              Starte jetzt
            </p>
            <p className="text-[#9A9A9A] text-sm leading-relaxed mb-6">
              Bereit für deine Transformation? Vereinbare jetzt deine persönliche
              Session — remote verfügbar, weltweit.
            </p>
            <Link
              to="/leistungen"
              className="inline-block btn-gold-shimmer border border-[#C9A84C] text-[#C9A84C] text-xs uppercase tracking-[0.18em] px-8 py-3 hover:bg-[#C9A84C] hover:text-[#050510] transition-all duration-300 mb-4"
              data-testid="footer-buchen-btn"
            >
              Jetzt buchen
            </Link>
            <div className="mt-4">
              <a
                href={`https://wa.me/${WHATSAPP_NUM}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#9A9A9A] text-xs hover:text-[#C9A84C] transition-colors"
              >
                <Phone size={12} />
                WhatsApp-Anfrage senden
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#1A1A2E] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#9A9A9A] text-xs">
            © {new Date().getFullYear()} Auralia Healing. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            {[
              { href: "/impressum", label: "Impressum" },
              { href: "/datenschutz", label: "Datenschutz" },
              { href: "/agb", label: "AGB" },
            ].map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-[#9A9A9A] text-xs hover:text-[#C9A84C] transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
